import React from 'react'

function InvoicesDetails() {
  return (
    <div>
      
    </div>
  )
}

export default InvoicesDetails
